module.exports = __webpack_public_path__ + "components/MapControl/svg/Sąd.svg?82bae1e6";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Sąd.svg
// module id = 2032
// module chunks = 0